import http from '@/utils/http/index';

// 获取品牌列表
export const queryBrandList = (params = {}) => http.get('/merchantLogoConfig/list', { params });

// 新增品牌
export const addBrand = (data) => http.post('/merchantLogoConfig/insert', data);

// 删除品牌
export const deleteBrand = (params) => http.delete('/merchantLogoConfig/delete', { params });

// 修改品牌信息
export const updateBrand = (data) => http.post('/merchantLogoConfig/update', data);

// 获取品牌信息
export const getBrandInfo = (params) => http.get('/merchantLogoConfig/load', { params });
